import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAch = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 32,
	height: 33,
	viewBox: "0 0 32 33",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("rect", {
		y: .163574,
		width: 32,
		height: 32,
		rx: 16,
		fill: "#3D73F3"
	}), /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M16.0238 7.33154C15.7832 7.33154 15.547 7.39586 15.3397 7.51783C15.332 7.52235 15.3244 7.52706 15.317 7.53194L8.72752 11.8469L8.72613 11.8478C8.25865 12.1559 8.11691 12.6878 8.29742 13.1421C8.471 13.5789 8.90928 13.8742 9.43431 13.8742H22.6132C23.1382 13.8742 23.5765 13.5789 23.7501 13.1421C23.9306 12.6878 23.7888 12.1559 23.3214 11.8478L23.32 11.8469L16.7305 7.53194C16.7231 7.52706 16.7155 7.52235 16.7078 7.51783C16.5005 7.39586 16.2643 7.33154 16.0238 7.33154ZM8.21899 20.5007C8.21899 19.8313 8.85624 19.5093 9.33396 19.5093H9.39496C9.39283 19.4896 9.39174 19.4694 9.39174 19.4491V15.8688C9.39174 15.5609 9.64133 15.3113 9.94922 15.3113H11.8046C12.1125 15.3113 12.3621 15.5609 12.3621 15.8688V19.4491C12.3621 19.4694 12.361 19.4896 12.3588 19.5093H14.5417C14.5395 19.4896 14.5385 19.4694 14.5385 19.4491V15.8688C14.5385 15.5609 14.788 15.3113 15.0959 15.3113H16.9513C17.2592 15.3113 17.5088 15.5609 17.5088 15.8688V19.4491C17.5088 19.4694 17.5077 19.4896 17.5055 19.5093H19.6884C19.6863 19.4896 19.6852 19.4694 19.6852 19.4491V15.8688C19.6852 15.5609 19.9347 15.3113 20.2427 15.3113H22.098C22.4059 15.3113 22.6555 15.5609 22.6555 15.8688V19.4491C22.6555 19.4694 22.6543 19.4896 22.6522 19.5093H22.7135C23.1913 19.5093 23.8285 19.8313 23.8285 20.5007V21.8026C23.8285 22.472 23.1913 22.794 22.7135 22.794H9.33396C8.85624 22.794 8.21899 22.472 8.21899 21.8026V20.5007Z",
		fill: "white"
	})]
});
export default SvgAch;
